import { config } from "@/data/config";

const sameAs = Object.values(config.Socials).filter(Boolean) as string[];

const personEntity = () => ({
	"@type": "Person" as const,
	"@id": `${config.Url}/#person`,
	name: config.Name,
	url: config.Url,
	image: `${config.Url}/images/avatar.png`,
	...(config.Email ? { email: config.Email } : {}),
	sameAs,
	jobTitle: "Software Engineer",
	worksFor: {
		"@type": "Organization",
		name: "Klaviyo",
		url: "https://www.klaviyo.com",
	},
	knowsAbout: [
		"Email Infrastructure",
		"Email Deliverability",
		"Software Engineering",
		"Developer Tooling",
	],
});

export const schema = {
	webSite: () => ({
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: config.Name,
		url: config.Url,
		description: config.Description,
	}),

	person: () => ({
		"@context": "https://schema.org",
		...personEntity(),
	}),

	profilePage: (url: string) => ({
		"@context": "https://schema.org",
		"@type": "ProfilePage",
		"@id": `${url}#profile`,
		url,
		dateCreated: "2024-01-01",
		dateModified: "2025-01-01",
		mainEntity: personEntity(),
	}),

	blog: () => ({
		"@context": "https://schema.org",
		"@type": "Blog",
		name: `${config.Name} — Blog`,
		url: `${config.Url}/blog`,
		description:
			"Thoughts, ideas, and insights on technology, development, and life.",
		author: personEntity(),
	}),

	collectionPage: (name: string, url: string, description: string) => ({
		"@context": "https://schema.org",
		"@type": "CollectionPage",
		name,
		url,
		description,
		author: personEntity(),
	}),

	contactPage: () => ({
		"@context": "https://schema.org",
		"@type": "ContactPage",
		name: `Contact ${config.Name}`,
		url: `${config.Url}/contact`,
		...(config.Email ? { email: config.Email } : {}),
		about: {
			"@type": "Person",
			"@id": `${config.Url}/#person`,
		},
	}),

	webPage: (name: string, url: string, description: string) => ({
		"@context": "https://schema.org",
		"@type": "WebPage",
		name,
		url,
		description,
		about: {
			"@type": "Person",
			"@id": `${config.Url}/#person`,
		},
	}),

	breadcrumb: (items: { name: string; url: string }[]) => ({
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: items.map((item, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: item.name,
			item: item.url,
		})),
	}),
};

export const toScript = (s: object) => ({
	type: "application/ld+json",
	children: JSON.stringify(s),
});
